import { defineMessages, type MessageDescriptor } from 'react-intl';

type MessageKeys =
	| 'viewMoreManageMemory'
	| 'betaLozenge'
	| 'backToRovoMemory'
	| 'backToRovoSettings'
	| 'backToRovoPersonalization'
	| 'manageMemoryModalMainHeader';

export const messages: Record<MessageKeys, MessageDescriptor> = defineMessages({
	viewMoreManageMemory: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.manage-memory',
		defaultMessage: 'Personalization',
		description: 'Side nav item for Manage Memory in the View More modal',
	},
	betaLozenge: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.manage-memory.beta-lozenge',
		defaultMessage: 'Beta',
		description: 'Beta lozenge label displayed next to the Memory nav item',
	},
	backToRovoMemory: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.manage-memory.back-to-rovo-memory',
		defaultMessage: 'Back to Rovo memory',
		description:
			'Back button label in the subscreen header that navigates back to the Rovo memory panel',
	},
	backToRovoSettings: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.manage-memory.back-to-rovo-settings',
		defaultMessage: 'Back to Rovo settings',
		description:
			'Back button label in the work profile subscreen that navigates back to the Rovo settings panel',
	},
	backToRovoPersonalization: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.manage-memory.back-to-rovo-personalization',
		defaultMessage: 'Back to Rovo personalization',
		description:
			'Back button label in the response and writing style subscreen that navigates back to the Rovo personalization panel',
	},
	manageMemoryModalMainHeader: {
		id: 'ai-mate.rovo-settings-modal.side-nav-modal.manage-memory.main-header',
		defaultMessage: 'Rovo personalization',
		description: 'Header display at the very top of the manage memory modal section',
	},
});
